
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>EW Trx Activity Type Log</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">EW Trx Activity Type Log</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="EWTrxActivityTypeLog">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'EWTrxActivityTypeLogList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">
                    
                    
            <div class="form-group required" >
              <label class="control-label">Trx Activity Type ID</label>
              <input type="text" id="trx_activity_type_id" name="trx_activity_type_id"
                     v-bind:class="{'has-error' : errors.has('trx_activity_type_id')}"
                     v-validate="'required'"
                     v-model="value.trx_activity_type_id" class="form-control trx_activity_type_id"
                     placeholder="Trx Activity Type ID">
              <div class="help text-danger" v-show="errors.has('trx_activity_type_id')">
                {{ errors.first("trx_activity_type_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Previous Data</label>
              <textarea id="previous_data" name="previous_data"
                 v-bind:class="{'has-error' : errors.has('previous_data')}"
                 v-validate="'required'"
                 v-model="value.previous_data" class="form-control previous_data"
                 placeholder="Previous Data"
                 rows="3"></textarea>
              <div class="help text-danger" v-show="errors.has('previous_data')">
                {{ errors.first("previous_data") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Current Data</label>
              <textarea id="current_data" name="current_data"
                 v-bind:class="{'has-error' : errors.has('current_data')}"
                 v-validate="'required'"
                 v-model="value.current_data" class="form-control current_data"
                 placeholder="Current Data"
                 rows="3"></textarea>
              <div class="help text-danger" v-show="errors.has('current_data')">
                {{ errors.first("current_data") }}
              </div>
            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'

export default {
  name: 'EWTrxActivityTypeLogForm',
  metaInfo: {
    title: 'EW Trx Activity Type Log | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    
    value: {
        
        
    },
    pre: {
      
    }
  }),
  methods: {
    
    
    
    handleSubmission () {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/ew_trx_activity_type_logs'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/ew_trx_activity_type_logs/' + _this.$route.params.id
            method = 'PUT'
          }
          
          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' },
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({'name': 'EWTrxActivityTypeLogList'})
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/ew_trx_activity_type_logs/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          });
      });
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params
      
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data
        }).catch((error) => {
          console.log(error.response)
        })
        
        
      }
      
      this.is_loading = false
    }
  },
  mounted () {
    this.initialize()
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>

        